export var BUY_PARTNER_CART_PREORDER = 'buy/partner_cart_preorder/v2';
export var BUY_PARTNER_CART_PREORDER_JOBS = 'buy/partner_cart_preorder_jobs/v2';
export var BUY_GET_OPTIONS = {
  Accept: 'application/json'
};